import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Button, Col, Divider, Form, Row, message, Spin } from 'antd';
import AutoCompleteFields from '../../components/inputsGroups/autoCompleteFields/autoCompleteFields';
import ProfileForm from '../../components/EditProfileForm';

import showConfirmWindow from '../../../../common/components/successPopup/successPopup';

import {
  editUserProfile,
  resetEditProfileStatus,
} from '../../redux/actions/EditProfile';
import { uploadAvatar } from '../../redux/actions/Avatar/uploadAvatarActions';
import { fieldsFabric } from '../../../../common/utils';
import { getProfileById } from '../../redux/actions/EditProfile';
import { unsetActiveProfile } from '../../redux/actions/ProfileList';
import { IconArrowLeft } from '../../../../common/ui/icons';
import { normalizeDate } from '../../../../common/utils/normalizeDate';
import { isObject } from '../../../../common/utils/isObject';

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileId: this.getProfileId(),
      form: fieldsFabric('form'),
      avatar: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    let { data } = props.currentProfile;
    if (data) {
      const { photo } = data.userId;
      if (photo) {
        state = { avatar: photo };
      }
    }
    return state;
  }

  compareStateWithProps = (props, state) => {
    _.reduce(
      props,
      (result, value, key) => {
        if (state.hasOwnProperty(key)) {
          state[key] = value;
        } else if (
          state.hasOwnProperty(
            key
              .split(/(?=[A-Z])/)
              .join('_')
              .toLowerCase()
          )
        ) {
          if (isObject(value)) {
            state[
              key
                .split(/(?=[A-Z])/)
                .join('_')
                .toLowerCase()
            ] = value[key];
          } else {
            state[
              key
                .split(/(?=[A-Z])/)
                .join('_')
                .toLowerCase()
            ] = value;
          }
        }
      },
      {}
    );
    return state;
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.currentProfile.data !== this.props.currentProfile.data) {
      const { currentProfile } = this.props;
      const user = currentProfile.data && currentProfile.data.userId;
      const company = currentProfile.data && currentProfile.data.companyId;
      let { form } = this.state;

      this.compareStateWithProps(user, form.user);
      this.compareStateWithProps(company, form.company);

      this.setState(form);
    }
  }

  componentDidMount() {
    if (this.state.profileId > 0) {
      if (!this.props.currentProfile.data) {
        this.props.getProfileById(this.state.profileId);
      }
    }
  }
  getProfileId() {
    const { clientId = 0 } = this.props.match && this.props.match.params;
    return clientId > 0 ? clientId : 0;
  }
  formChange = formState => {
    this.setState({ form: formState });
  };
  handleAvatarChange = avatar => {
    this.setState({ avatar: avatar });
  };
  handleFormSubmit = e => {
    const { match } = this.props;
    const { clientId } = match.params;
    const { form } = this.state;
    const { validateFields } = this.props.form;

    const {
      editUserProfile,
      // unsetActiveProfile
    } = this.props;
    normalizeDate(form, 'YYYY-MM-DD');
    validateFields(errors => {
      if (!errors) {
        localStorage.removeItem('selectedProfile');
        showConfirmWindow({
          ...{
            title: 'Внимание',
            content: 'Вы действительно хотите сохранить внесенные изменения?',
            okText: 'Сохранить изменения',
            cancelText: 'Отмена',
            className: 'confirm-red',
            okType: 'primary',
            width: 432,
            cancelButtonProps: {
              type: 'primary',
              ghost: true,
            },
          },
          onOk: () => {
            editUserProfile({ data: form, profileId: clientId });
          },
        });
      } else {
        message.error('Заполните все обязательные поля!');
      }
    });
  };
  render() {
    const { form, avatar } = this.state;
    const { loading } = this.props.currentProfile;
    const formItemLayout = { labelCol: { span: 6 } };
    return (
      <div id="addLicensee" className="basicForm">
        <Row type="flex" justify="space-between" gutter={16}>
          <Col span={18}>
            {loading ? (
              <Spin />
            ) : (
              <div className="formContainer">
                <Form
                  {...formItemLayout}
                  className="licenseeForm"
                  hideRequiredMark
                >
                  <React.Fragment>
                    <h2>Клиент</h2>
                    <AutoCompleteFields
                      avatar={avatar}
                      formState={form.user}
                      avatarChange={this.handleAvatarChange}
                      uploadAvatar={this.props.uploadAvatar}
                    />
                  </React.Fragment>
                  <Divider />
                  <React.Fragment>
                    <h2>Компания</h2>
                    <ProfileForm
                      formData={form}
                      form={this.props.form}
                      formChange={this.formChange}
                    />
                  </React.Fragment>
                </Form>
              </div>
            )}
          </Col>
          <Col span={6}>
            <div className="sidebarContainer">
              <div className="button">
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={this.handleFormSubmit}
                >
                  Сохранить
                </Button>
                <Button
                  style={{ marginTop: 20 }}
                  onClick={() => this.props.history.goBack()}
                >
                  <IconArrowLeft />
                  Отмена
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
const ProfileEdit = Form.create()(EditProfile);
export default connect(
  state => ({
    user_id: state.Authorization.user.id,
    currentProfile: state.Authorization.edit.profile,
    profile: state.Authorization.edit.profile,
  }),
  {
    editUserProfile,
    uploadAvatar,
    getProfileById,
    unsetActiveProfile,
    resetEditProfileStatus,
  }
)(ProfileEdit);
